import React from "react";
import AppRouter from "./router";
import { ClaimProvider } from "./claimProvider";

function App() {
  return (
    <ClaimProvider>
      <AppRouter />
    </ClaimProvider>
  );
}

export default App;
//1129495874939556
